export default "__VITE_ASSET__ansPFRlb__"